// S11-9: admin console version-info hook. Mirrors the dashboard's
// useVersionInfo — kept separate because the two apps don't share a
// module tree.

import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api.js';

export function useVersionInfo() {
  return useQuery({
    queryKey: ['version'],
    queryFn: () => api.get('/version'),
    staleTime: Infinity,
    retry: 1,
    select: (resp) => {
      const d = resp?.data ?? resp ?? {};
      return {
        version: d.version || 'dev',
        commit: d.commit || 'dev',
        builtAt: d.built_at || null,
      };
    },
  });
}
